import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'default' | 'large';
  label?: string;
  fullscreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'default', 
  label,
  fullscreen = false
}) => {
  const spinnerClass = size === 'large' ? 'spinner spinner-lg' : 'spinner';
  
  if (fullscreen) {
    return (
      <div className="spinner-fullscreen">
        {label ? (
          <div className="spinner-with-label">
            <div className={spinnerClass}></div>
            <div className="label">{label}</div>
          </div>
        ) : (
          <div className={spinnerClass}></div>
        )}
      </div>
    );
  }
  
  if (label) {
    return (
      <div className="spinner-with-label">
        <div className={spinnerClass}></div>
        <div className="label">{label}</div>
      </div>
    );
  }
  
  return (
    <div className="spinner-container">
      <div className={spinnerClass}></div>
    </div>
  );
};

export default LoadingSpinner;
